import { Orbit } from 'lucide-react'
import { Link, useLocation } from 'react-router-dom'

export default function AthleteGrowthShortcut() {
  const location = useLocation()
  if (!['/athlete', '/player'].includes(location.pathname)) return null

  return (
    <Link
      to="/athlete/growth"
      className="border-hd-purple/35 bg-hd-dark/95 text-hd-purple hover:bg-hd-purple/10 fixed bottom-5 left-4 z-[75] inline-flex min-h-12 items-center gap-2 rounded-2xl border px-4 text-xs font-black shadow-2xl backdrop-blur-xl transition hover:-translate-y-0.5 sm:left-6"
      aria-label="Open ARGUS athlete flywheel"
    >
      <Orbit className="h-4 w-4" /> Flywheel
    </Link>
  )
}
